




import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    name: "ImageView"
})
export default class ImageView extends Vue {
    @Prop({ required: true }) url: string;

    timestamp = 0;
    attemptsNumber = 3;
    currentAttempt = 1;
    isLoaded = false;

    created() {
        this.loadImage();
    }

    loadImage() {
        const img = new Image();
        img.onerror = () => {
            if (this.currentAttempt >= this.attemptsNumber ) {
                this.isLoaded = false;
                return;
            }

            setTimeout(() => {
                this.timestamp = new Date().getTime();
                this.currentAttempt++;
                img.src = this.url + `?v=${new Date().getTime()}`;
            }, 1000);
        }

        img.onload = () => {
            this.isLoaded = true;
            this.$emit('loaded');
        }

        img.src = this.url;
    }
}
